import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

// FORMIK COMPONENTS
import { Field } from "formik";

export default function InputSelect({
	name = "",
	label = "",
	disabled = false,
	placeholder = "",
	select_list = [],
	sx = {},
	size = "medium",
	full_width = true,
	on_change = () => {},
	helper_text = null,
}) {
	return (
		<Field id={name} name={name}>
			{({ meta, field }) => {
				if (!field.value) {
					field.value = "";
				}

				return (
					<FormControl sx={{ ...sx }} fullWidth={full_width}>
						<InputLabel size={size}>{label}</InputLabel>
						<Select
							disabled={disabled}
							label={label}
							placeholder={placeholder}
							error={meta.error && meta.touched}
							{...field}
							onChange={(event) => {
								field.onChange(event);
								on_change(event);
							}}
							size={size}
							aria-labelledby={name}
						>
							{select_list.map((selectItem) => (
								<MenuItem
									id={name}
									key={selectItem.value}
									value={selectItem.value}
									disabled={selectItem.disabled}
								>
									{selectItem.disabled ? <em>{selectItem.label}</em> : selectItem.label}
								</MenuItem>
							))}
						</Select>

						{meta.error && meta.touched && meta.error ? (
							<FormHelperText sx={{ color: "#dc3545", mt: 0.5 }}>
								{meta.error && meta.touched && meta.error}
							</FormHelperText>
						) : (
							// Show an optional helper text when provided and no error is active
							helper_text && <FormHelperText sx={{ mt: 0.5 }}>{helper_text}</FormHelperText>
						)}
					</FormControl>
				);
			}}
		</Field>
	);
}
